import { Component, OnInit, Input, ViewChildren, Output, Renderer2, OnDestroy } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { EgretNotifications2Component } from '../egret-notifications2/egret-notifications2.component';
import {LoginService} from '../../services/aplicacao-service/login.service';
import {UtilizadoresService} from '../../services/aplicacao-service/utilizadores.service';
import {UserDataService} from '../../services/data/user-data.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {JwtHelperService} from '@auth0/angular-jwt';
import {LocalStoreService} from '../../services/local-store.service';
import {Utilizadores} from '../../models/aplicacao/utilizadores';
import { OnDestroyService } from '../../services/on-destroy.service';
import { Aplicacao } from '../../models/aplicacao/aplicacao';
import { AppStoreService } from 'app/shared/services/aplicacao-service/data/app-store.service';
import { AppDataService } from '../../services/data/app-data.service';
import { DashboardService } from '@services/dashboard/dashboard.service';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  styles: [`
      .msg-expiracao {
          background: #f78c8c!important;
          color:#000000;
      }
  `]
})
export class HeaderSideComponent implements OnInit, OnDestroy {
  @Input() notificPanel;
  @Input() isCustomizerOpen: boolean;
  @ViewChildren(EgretNotifications2Component) noti;
  public egretThemes;
  public layoutConf: any;
  fotoPerfil: string;
  fotografia?: string;
  user: Utilizadores;
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  subscricoes: Subscription[] = [];
  mostrarAviso = false;
  diasEmFalta = parseInt(localStorage.getItem('diasEmFalta'), 10);
  numeroNotificacoes:number=0;
  userAdmin=false;
  utilizador:any;

  protected readonly window = window;
  aplicacao!: Aplicacao;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public loginService: LoginService,
    public localStore: LocalStoreService,
    private utilizadoresService: UtilizadoresService,
    private data: UserDataService,
    public appStoreService: AppStoreService,
    public appDataService: AppDataService,
    private dashboardService: DashboardService,
    private onDestroyService: OnDestroyService
  ) {}
  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    const token = localStorage.getItem('token');
    this.decodedToken = this.jwtHelper.decodeToken(token);
    this.getUserFromLocalStorage();
    this.loginService.decodedToken = this.decodedToken;
    this.getDadosAplicacao();
    this.utilizador = this.loginService.getUtilizadorSessao();
    this.userAdmin = this.utilizador?.sistema;
  }



  getDadosAplicacao() {
    this.subscricoes.push(
      this.appStoreService.getAplicacao().subscribe((res: any) => {
        this.aplicacao = res;
      })
    );
  }

  desactivarAviso() {
    this.appDataService.$mostrarAviso.next(false);
  }

  getUserFromLocalStorage() {
    if (this.localStore.getItem('_utilizador')) {
      this.user = this.localStore.getItem('_utilizador');
      this.fotografia = this.user.fotografia;
      this.fotoPerfil = this.user.fotografia;
    } else {
      this.getImagemUtilizador(this.decodedToken.nameid);
    }
  }

  getImagemUtilizador(id: number) {
    this.subscricoes.push(
        this.utilizadoresService
            .getUtilizador(id)
            .subscribe((res) => {
              this.fotografia = res.fotografia;
              this.data.setFotoPerfil(res.fotografia);
              this.subscricoes.push(
                  this.data.getFotoPerfil().subscribe((foto) => {
                    this.fotoPerfil = foto;
                  })
              );
            })
    );
  }
  logout() {
    localStorage.removeItem('clean_cache');
    this.loginService.logout();
  }

  changeTheme(theme) {
    // this.themeService.changeTheme(theme);
  }
  toggleNotific() {
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full'
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed'
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
        sidebarCompactToggle: false
      }, {transitionClass: true});
    }

    // * --> compact
    this.layout.publishLayoutChange({
      sidebarStyle: 'compact',
      sidebarCompactToggle: true
    }, {transitionClass: true});

  }

  fecharCustomizer(event: any) {
    this.isCustomizerOpen = event;
  }

  onSearch(e) {
    //   console.log(e)
  }

  reloadWindow() {
    // @ts-ignore
    document.location.reload(true);
  }

  ngOnDestroy() {
  this.onDestroyService.destruir(this.subscricoes);
  }
}
